import { render, staticRenderFns } from "./FloatButton.vue?vue&type=template&id=53da0782&scoped=true"
import script from "./FloatButton.vue?vue&type=script&lang=js"
export * from "./FloatButton.vue?vue&type=script&lang=js"
import style0 from "./FloatButton.vue?vue&type=style&index=0&id=53da0782&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53da0782",
  null
  
)

export default component.exports